/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Backdrop, Divider, Card, CardHeader, CardContent, CardActions, Paper, Tooltip, Typography, Avatar, IconButton, FormControlLabel, Switch, Collapse, TextField  } from '@material-ui/core'

import Event from '@material-ui/icons/Event'
import Edit from '@material-ui/icons/Edit'
import Clear from '@material-ui/icons/Clear'
import Check from '@material-ui/icons/Check'
import ArrowRightAlt from '@material-ui/icons/ArrowRightAlt'

import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'

import { format } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

import cronstrue from 'cronstrue';
import CronScheduler from './CronScheduler';

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    backdrop : {
        zIndex: theme.zIndex.drawer + 1,
    }
})

class CronEditor extends Component {
    state = {
        recursive : false
    }

    convertToISOString = (date_string) => {
        let date = new Date(date_string)
        var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            var norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return date.getFullYear() +
                '-' + pad(date.getMonth() + 1) +
                '-' + pad(date.getDate()) +
                'T' + pad(date.getHours()) +
                ':' + pad(date.getMinutes()) +
                ':' + pad(date.getSeconds()) +
                dif + pad(tzo / 60) +
                ':' + pad(tzo % 60);
    }

    componentDidUpdate () {
        console.log("Schedule :", this.props.schedule)
    }

    renderCronCheck = () => {
        return (
            <Fragment>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                    <FormControlLabel
                        value = "end"
                        disabled = {this.props.schedule.job_status === "Scheduled" ? true : false}
                        control={<Switch size = 'small' checked={this.props.schedule.recursive} onChange={() => this.props.updateState('recursive', !this.props.schedule.recursive)} name="Recursive" color = 'primary'/>}
                        label="This is a recurring event"
                    />
                </div>
            </Fragment>
        )
    }

    renderCronEditor = () => {
        if (this.props.schedule.recursive) {
            return (
                <div style = {{width : '80vw', padding : '10px'}}>
                    <CronScheduler 
                        value = {this.props.schedule.cron_expression} 
                        setValue = {(newValue) => this.props.updateState('cron_expression', newValue)} 
                        disabled = {this.props.disabled}
                    />
                </div>
            )
        }
    }

    renderEditor = () => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        console.log("Current Time Zone : ", timezone )
        return (
            <Card style = {{
                minWidth : '40vw',
                maxWidth : '85vw',
                maxHeight : '75vh',
                overflow : 'scroll'
            }}>
                <CardHeader
                    avatar = {
                        <Avatar aria-label="scheduler" style = {{
                            backgroundColor : "#2296f3"
                        }}>
                            <Event style = {{color : "#FFFFF"}} fontSize = 'small'/>
                        </Avatar>
                    }
                    action = {
                        <Tooltip title = "Cancel">
                            <IconButton aria-label = "close editor" onClick = {() => this.props.updateState('editor', false)}>
                                <Clear style = {{color : "#EE0101"}}/>
                            </IconButton>
                        </Tooltip>
                    }
                    title = {
                        <TextField
                            label = 'Schedule Name'
                            value = {this.props.schedule.job_name}
                            disabled = {this.props.disabled}
                            onChange = {(event) => this.props.updateState('job_name', event.target.value)}
                            error = {this.props.name_error !== null ? true : false}
                            helperText = {this.props.name_error !== null ? this.props.name_error : null}
                        />
                    }
                    subheader = {"All Date and Time are in Local Time Zone"}
                />
                <CardContent>
                    <Divider style = {{marginBottom : '5px'}}/>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'space-evenly', marginTop : '25px', alignItems : 'center'}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                label = {"Start Date Time"}
                                clearable = {false}
                                value={this.props.schedule.start_time}
                                onChange={(value) => this.props.updateState('start_time', zonedTimeToUtc(format(new Date(value),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString())}
                                error = {this.props.start_date_error !== null ? true : false}
                                helperText= {this.props.start_date_error !== null ? this.props.start_date_error : "Choose Date and Time"}
                                format="dd/MM/yyyy HH:mm"
                                disabled = {this.props.disabled}
                                disablePast
                            />
                        </MuiPickersUtilsProvider>
                        <ArrowRightAlt fontSize = "large" style = {{color : "#2296f3"}} />
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                label = {"End Date Time"}
                                clearable
                                value={this.props.schedule.end_time}
                                onChange={(value) => this.props.updateState('end_time', zonedTimeToUtc(format(new Date(value),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString())}
                                helperText="Choose Date and Time"
                                format="dd/MM/yyyy HH:mm"
                                disabled = {this.props.disabled}
                                disablePast
                            />
                        </MuiPickersUtilsProvider> 
                    </div>
                    {this.renderCronCheck()}
                    {this.renderCronEditor()}
                </CardContent>
                <CardActions>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse'}}>
                        <Tooltip title = "Submit">
                            <IconButton aria-label = "submit schedule" onClick = {this.props.submitSchedule} disabled = {this.props.disabled}>
                                <Check style = {{color : "#03CD27"}} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </CardActions>
            </Card>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Backdrop className = {classes.backdrop} open = {this.props.editor}>
                    {this.renderEditor()}
                </Backdrop>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(CronEditor);